<template>
        <div>

                <div class="SubaccountManage">
        <h4>子账号管理</h4>
        <el-form ref="form" :label-position="labelPosition" :model="QueryBuilder" label-width="80px" size="mini">
            <el-form-item label="登录账号">
                <el-input clearable v-model.trim="QueryBuilder.code" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="用户名">
                <el-input clearable v-model.trim="QueryBuilder.name" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="使用状态">
                <el-select v-model="QueryBuilder.status" placeholder="请选择">
                    <el-option label="启用" value="Y"></el-option>
                    <el-option label="停用" value="N"></el-option>
                </el-select>
            </el-form-item>
            <el-button type="primary" style="margin-left:0px" @click="onSubmit()">查询</el-button>
             <el-button type="primary" style="margin-left: 0px;background: white;border: 1px solid #FF4D01;color: #FF4D01;" @click="handleClear"
        >重置</el-button
      >
        </el-form>
        <el-button class="addClass" @click="addsubaccount()">新建子账号</el-button>
        <el-table 
            border 
            :data="tableData" max-height="500px"
            tooltip-effect="dark" 
            :header-cell-style="{background:'#F3F3F3'}"
            ref="multipleTable"
            style="width: 97% !important;margin-left:32px;margin-bottom:15px;">
            <el-table-column type="index" label="序号" width="60px" min-width="8%"></el-table-column>
            <el-table-column prop="code" label="登录账号" min-width="10%"></el-table-column>
            <el-table-column prop="name" label="用户名" min-width="10%"></el-table-column>
            <el-table-column prop="mobilePhone" label="手机号" min-width="10%"></el-table-column>
            <el-table-column prop="createTime" label="创建时间" min-width="10%"></el-table-column>
            <el-table-column prop="roleName" label="所属角色" min-width="10%"></el-table-column>
            <el-table-column prop="roleName" label="是否主账号" min-width="10%">
                <template slot-scope="scope">
                        {{scope.row.isAdmin == 'Y' ? '是' : '否'}}
                </template>
            </el-table-column>
            <el-table-column prop="statuss" label="使用状态" min-width="7%"></el-table-column>
            <el-table-column prop="operation" label="操作" min-width="10%">
              <template slot-scope="scope">
                <el-button @click="orderdetails(scope.row)" type="text" size="small">修改</el-button>
              </template>
            </el-table-column>
        </el-table>
        <div  class="panelBox" v-show="panelBox">
            <div class="panel">
                <i class="el-icon-circle-close close" @click="closePanel()"></i>
                <h4 v-if="addPanel">新建子账号</h4>
                <h4 v-else>修改子账号</h4>
                <!-- hide-required-asterisk -->
                <el-form ref="MessageForm" :label-position="labelPosition" :rules="rules" :model="MessageForm" 
                label-width="80px" size="mini" >
                    <el-form-item label="用户名" prop="name">
                        <el-input v-model="MessageForm.name" placeholder="请输入用户名"></el-input>
                    </el-form-item>
                    <el-form-item label="登录账号" prop="username">
                        <el-input v-model="MessageForm.username" :disabled="true" placeholder="登录账号自动生成"></el-input>
                    </el-form-item>
                    <el-form-item label="密码" prop="pass">
                        <!-- <el-input v-model="MessageForm.password" type="password" placeholder="请输入"></el-input> -->
                        <el-input type="password" v-model="MessageForm.pass" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="确认密码" prop="checkPass">
                        <!-- <el-input v-model="MessageForm.checkPass" type="password" placeholder="请输入"></el-input> -->
                        <el-input type="password" v-model="MessageForm.checkPass" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号" prop="mobilePhone">
                        <el-input v-model="MessageForm.mobilePhone" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="邮箱" prop="email">
                        <el-input v-model="MessageForm.email" placeholder="请输入"></el-input>
                    </el-form-item>
                   
                    <el-form-item label="所属角色">
                        <el-select v-model="MessageForm.roleId" placeholder="请选择所属角色">
                            <el-option :label="item.cnName" :value="item.id" v-for="(item ,index) in rolelist" :key="index"></el-option>
                        </el-select>
                    </el-form-item>
                     <el-form-item label="状态" prop="status">
                        <el-select v-model="MessageForm.status" placeholder="请选择启用">
                            <el-option label="启用" value="Y"></el-option>
                             <el-option label="禁用" value="N"></el-option>

                        </el-select>
                    </el-form-item>
                    <el-row v-if="addPanel">
                        <el-button size="small" @click="ruleForm('MessageForm')">确认并继续新建</el-button>
                        <el-button size="small" @click="addaccount('MessageForm')">确认新建</el-button>
                    </el-row>
                    <el-row v-else>
                        <el-button size="small" @click="confirmChange('MessageForm')">确认修改</el-button>
                    </el-row>
                </el-form>
            </div>
        </div>
    </div>
        </div>


    
</template>
<script>
import qs from "qs";
export default {
    name:"SubaccountManage",
    data() {
        var validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入密码'));
            } else {
                if (this.MessageForm.checkPass !== '') {
                    this.$refs.MessageForm.validateField('checkPass');
                }
                callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            console.log(value);
            if (value === '') {
                callback(new Error('请输入确认密码'));
            } else if (value !== this.MessageForm.pass) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        var isMobileNumber= (rule, value, callback) => {
          
            const phoneReg = /^1[3|4|5|6|7|8][0-9]{9}$/
           
		    if (!value) {
		      return callback(new Error('电话号码不能为空'))
            }
           
            if (!phoneReg.test(value)) {
		      return callback(new Error('手机号格式错误'))
            }
            callback();
            
		    // setTimeout(() => {
		      
		    //   if (!Number.isInteger(+value)) {
		    //     callback(new Error('请输入数字值'))
		    //   } else {
		    //     if (phoneReg.test(value)) {
		    //       callback()
		    //     } else {
		    //       callback(new Error('电话号码格式不正确'))
		    //     }
		    //   }
		    // }, 100)
        };
        return {
            CodeDisabled:false,//用户名禁用
            customerid:'',//用户id
            labelPosition: 'left',
            QueryBuilder: {//表单
                code: '',
                name:"",
                status:'Y'
            },
            MessageForm:{//form弹框表单数据
                name:"",
                username:"",
                pass:"",
                checkPass:"",
                mobilePhone:"",
                email:"",
                roleId:"",
                userId:"",
                status:true
            },
            rules: {
                name: [
                    { required: true, message: '请输入用户名', trigger: 'blur' }
                ],
                // username: [
                //     { required: true, message: '请输入用户名', trigger: 'blur' }
                // ],
                pass: [
                    { required: true,validator: validatePass, trigger: 'blur' }
                ],
                checkPass: [
                    { required: true,validator: validatePass2, trigger: 'blur' }
                ],
                mobilePhone: [
                    // { required: true, message: '请输入手机号', trigger: 'change' }
                    { required: true, message: "请输入手机号码", trigger: "blur" },
                    { validator: isMobileNumber, trigger: "blur" }
                ],
                email: [
                    { required: true, message: '请输入邮箱地址', trigger: 'blur' },
                    { type: 'email', message: '请输入正确的邮箱地址', trigger:  'blur' }
                ],
                roleId: [
                    { required: true,trigger: 'change', type: 'array', message: '请至少选择一个所属角色', }
                ],
                status: [
                    { required: true, trigger: 'change',message: '请选择状态', }
                ],
            },
            tableData:[
                // {
                //     code:"",
                //     name:"",
                //     mobilePhone:"",
                //     roleId:"",
                //     roleName:"",
                //     status:""
                // }
            ],
            panelBox:false,//弹框显示隐藏
            addPanel:true,//新建子账号
            codeid:"",
            statusid:'Y',
            userIdid:"",
            // recomposePanel:false,
            rolelist:[],//所属角色下拉列表
            createType: 1
        }
    },
    watch: {
    },
    methods: {
        // 清除表单
        handleClear(){
            this.QueryBuilder =  {//表单
                code: '',
                name:"",
                status:'Y'
            },
            this.onSubmit()
        },
        onSubmit(){//点击查询
            this.getAllAccount()
        },
        addsubaccount() {//点击新建子账号
            this.panelBox = true;
            this.addPanel = true;
            this.userIdid ="";
            this.codeid="";
            this.CodeDisabled= false;
            this.MessageForm = {
                name:"",
                username:"",
                pass:"",
                checkPass:"",
                mobilePhone:"",
                email:"",
                roleId:"",
                userId:""
            };
            this.$refs.MessageForm.resetFields();//重置form表单
        },
        closePanel(){//关闭弹框
            this.panelBox = false;
        },
        orderdetails(data){//点击table修改
            // console.log(data);
            this.CodeDisabled= true;
            this.userIdid = data.userId;
            this.codeid = data.code;
            this.editpersonal(data.userId);
            this.$refs.MessageForm.resetFields();//重置form表单
            this.panelBox = true;
            this.addPanel = false;
        },
        confirmChange(MessageForm){//确认修改
            this.codeid = this.MessageForm.username;
            // this.AddAmendAccount();
            this.addaccount(MessageForm);
            // this.panelBox = false;
        },
        addaccount(MessageForm){//确认新建
            // this.$refs[MessageForm].resetFields();
            this.$refs[MessageForm].validate((valid) => {
                if (valid) {
                    // console.log("成功")
                    this.xinjiansuccess();
                     
                } else {
                    console.log('error submit!!');
                    // return false;
                }
            });
        },
        xinjiansuccess(){//新建成功
            this.createType = 2
            // console.log(this.MessageForm)
            this.codeid = this.MessageForm.username;
            this.AddAmendAccount();
            // this.panelBox = false;
            // this.$refs[MessageForm].resetFields();
        },
        ruleForm(MessageForm) {//确认并继续新建
            this.createType = 1
            this.$refs[MessageForm].validate((valid) => {
                if (valid) {
                     this.codeid = this.MessageForm.username;
                     this.AddAmendAccount();

                    // this.xinjiansuccess();
                    // this.panelBox = true;
                    
                } else {
                    // console.log('error submit!!');
                    
                    return false;
                }
            });
            
        },
        succeedwarning(data) {//成功新建子账户提醒
            this.$message({
                message: data,
                type: 'success'
            });
        },
        getRoleAlldata(){//所属角色所有的数据
            let params = {
                "roleName": "",
                "status":1
            };
            let that = this;
            that.axios.get(
                "/authorization/getSubAccountRoleList",
                {params}
            )
            .then((response)=> {
                // console.log(response.data.datas);//.data.datas
                that.rolelist = response.data.datas;
            })
            .catch(function (error) {
                console.log(error);
            });
        },
        getAllAccount(){//获取全部子账户信息
            let data = {
                "code": this.QueryBuilder.code,
                "customerId": this.customerid,
                "name": this.QueryBuilder.name,
                "status": this.QueryBuilder.status
            };
            let that = this;
            that.axios.post(
                "/user/queryUserInfos",
                data
            )
            .then(function (response) {
                // console.log(response.data.datas);
                that.tableData = response.data.datas;
                for(var i=0;i<that.tableData.length;i++){
                    if(that.tableData[i].status == "Y"){
                        that.tableData[i].statuss = "启用";
                    }else if(that.tableData[i].status == "N"){
                        that.tableData[i].statuss = "停用";
                    }
                }
                
            })
            .catch(function (error) {
                console.log(error);
            });
        },
        AddAmendAccount(){//新增、修改子账户
        let  that = this
            let data = {
                "code": this.codeid,//用户code
                "customerId": this.customerid,
                "email": this.MessageForm.email,
                "mobilePhone": this.MessageForm.mobilePhone,
                "name": this.MessageForm.name,
                "password": this.MessageForm.checkPass,
                "roleId": this.MessageForm.roleId,//所属角色this.roleIdid
                "status": this.MessageForm.status,
                "userId": this.userIdid,
            };
            // console.log(data);
            this.axios.post(
                "/user/saveOrUpdateUserInfo",
                data
            )
            .then(response=> {

                if(response.data.code!= 200){
                    this.$message.info(response.data.message)
                    this.panelBox = true;
                    return
                }

                if(this.createType != 1){
                     this.panelBox = false;
                }
                
               
                this.$message.success(response.data.message)
                this.getAllAccount();
                
                
                
                // 成功后清空表单
                this.userIdid ="";
                        this.codeid="";
                        this.CodeDisabled= false;
                        this.MessageForm = {
                            name:"",
                            username:"",
                            pass:"",
                            checkPass:"",
                            mobilePhone:"",
                            email:"",
                            roleId:"",
                            userId:""
                        };
                this.$refs[MessageForm].resetFields();
                

                // console.log(response);
                // if(response.data.message == "成功"|| response.data.message == "success.msg"){
                //     this.succeedwarning("添加成功");
                //     this.getAllAccount();
                //     this.closePanel();
                // }else if(response.data.message == "修改成功"){
                //     this.succeedwarning("修改成功");
                //     this.getAllAccount();           
                // }else if(response.data.message == "服务器异常"){
                //     this.succeedwarning("操作失败,原因未知");
                // }
                // this.succeedwarning(response.data.message);
            })
            .catch( error => {
                console.log(error);
                // this.$message.info(error.data.message)
            });
        },
        editpersonal(userId){//编辑用户信息获取
            let params = {
                "userId": userId,
            };
            // console.log(params);
            let that = this;
            that.axios.get(
                "/user/findUserInfoById/"+userId,
                {params}
            )
            .then((response)=> {
                // console.log(response.data.data);//.data.datas
                this.MessageForm = response.data.data;
                this.$set(this.MessageForm, 'pass', response.data.data.password);
                this.$set(this.MessageForm, 'checkPass', response.data.data.password);
                this.$set(this.MessageForm, 'username', response.data.data.code);
                // this.MessageForm.username = data.code;
                // this.MessageForm.mobilePhone = data.mobilePhone;
                
            })
            .catch(function (error) {
                console.log(error);
            });

        }
    },
    created () {
        let publics = this.sessionGetUserInfo()
        this.customerid = publics.customerid;
    },
    mounted () {
        this.getRoleAlldata();
        this.getAllAccount();
    }
}
</script>

<style scoped>
.SubaccountManage{
    position: relative;
    /* width: 98%; */
    /* height: 685px; */
    /* margin: 30px; */
    /* margin-top: 12px; */
    background: #FFFFFF;
     box-shadow: rgb(107 105 105 / 21%) 0px 0px 20px 0px; 
      border-radius: 10px;
    box-sizing: border-box;
    overflow: hidden;
}
.SubaccountManage h4{
  width: 100%;
  height: 24px;
  padding-top: 25px;
  padding-left: 31px;
  font-size: 24px;
  font-family: "PingFang-SC-Bold";
  color: #343434;
}
.SubaccountManage .addClass{
    display: block;
    width: 150px;
    height: 40px;
    margin-top: 8px;
    margin-bottom: 21px;
    margin-left: 31px;
    background: #FFFFFF;
    color: #FF4D01;
    border: 1px solid #FF4D01;
    border-radius: 5px;
}
.SubaccountManage .addClass:hover{
    background: #FF4D01;
    color: #fff;
}
/* 弹框 */
.SubaccountManage .panelBox{
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.35);
    z-index: 2;
}
.SubaccountManage .panelBox .panel{
    position: absolute;
    top: calc(50% - 290px);
    left: calc(50% - 260px);
    width: 520px;
    /* height: 600px; */
    background: #fff;
    border-radius: 10px;
}
.SubaccountManage .panelBox .panel i.close{
    position: absolute;
    top: 25px;
    right: 20px;
    font-size: 24px;
}
.SubaccountManage .panelBox .panel i:hover{
    color: #409EFF;
}
.SubaccountManage .panelBox .el-button--small, .SubaccountManage .panelBox .el-button--small.is-round{
    width: 175px;
    height: 40px;
    margin-right: 8px;
    color: #FF4D01;
    border: 1px solid #FF4D01;
    border-radius: 5px;
}
.SubaccountManage .panelBox .el-row{
    margin-left: 80px;
}
.SubaccountManage .panelBox .el-button--small:hover, 
.SubaccountManage .panelBox .el-button--small.is-round:hover{
    background: #FF4D01;
    color: #fff;
}
/* element */
/* .SubaccountManage .panelBox .panel .el-button--small, .el-button--small.is-round{
    margin-left: 112px;
} */
.SubaccountManage .panelBox .el-form .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item{
    width: 92%;
}
.SubaccountManage .el-form{
  margin-top: 30px;
  margin-left: 31px;
  margin-bottom: 10px;
}
.SubaccountManage .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item{
  width: 23%;
  height: 40px;
  margin-right: 5%;
  display: inline-block;
}
.SubaccountManage .el-form .el-input--mini .el-input__inner{
    height: 36px;
    line-height: 36px;
}
.SubaccountManage .el-button--primary{
  width: 102px;
  height: 36px;
  padding: 0;
  background: #FF4D01;
  border-radius: 5px;
  border: none;
}
.SubaccountManage .el-table td, .el-table th{
    text-align: center;
}
/* table 滚动条 */
.SubaccountManage .el-table__body-wrapper::-webkit-scrollbar{
    width: 3px;
}
.SubaccountManage .el-table__body-wrapper::-webkit-scrollbar-thumb{
    border-radius: 2px;
    height: 50px;
    background: #409EFF;
}
.SubaccountManage .el-table__body-wrapper::-webkit-scrollbar-track{
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 2px;
    background: #eee;
}

/deep/ .el-form-item{
  margin-bottom: 8px;
  line-height: 28px;
}

/deep/ .el-input__inner{
  height: 34px;
}
</style>



// WEBPACK FOOTER //
// src/components/PersonalCenter/accountManage/SubaccountManage.vue